<template>
  <div>
    <div>
      <el-row :gutter="10" style="margin: 10px 15px">
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span> 时间类型： </span>
          <el-radio-group v-model="dataTpye" @change="initData" size="mini">
            <el-radio label="currMonth" v-if="dataRange === 'month'"
              >当月</el-radio
            >
            <el-radio label="currQuarter" v-if="dataRange === 'quarter'"
              >当季</el-radio
            >
            <el-radio label="all">本年累计</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span> 数据指标： </span>
          <el-select
            v-model="dataIndex"
            placeholder="请选择"
            @change="initData"
            size="mini"
          >
            <el-option
              v-for="item in dataIndexOptions"
              size="mini"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span> 数据类型： </span>
          <el-select
            v-model="dataRange"
            @change="dataRangeChange"
            placeholder="请选择"
            size="mini"
          >
            <el-option
              v-for="item in dataRangeOptions"
              size="mini"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :lg="8" v-if="dataRange === 'month'">
          <span style="margin-left: 40px"> 时间： </span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-model="times"
            type="month"
            value-format="yyyy-MM"
            @change="initData"
            size="mini"
            :picker-options="pickerOptions"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-col>
        <el-col :xs="24" :lg="8" v-if="dataRange === 'quarter'">
          <span>
            <quarter
              style="margin-left: 40px"
              :default-value="defaultQuarterValue"
              v-on:getQuarter="getQuarter"
            ></quarter>
          </span>
        </el-col>
        <el-col :xs="24" :lg="8" v-if="dataRange === 'year'">
          <span style="margin-left: 40px"> 时间： </span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            type="year"
            v-model="times"
            value-format="yyyy"
            size="mini"
            @change="yearChange"
            :picker-options="pickerOptions"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin: 10px 15px" v-if="showArea">
        <el-col align="center" style="font-size: 16px">
          全县{{
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }}情况
        </el-col>
      </el-row>
      <el-row style="margin: 10px 15px">
        <el-col :span="24">
          <Area v-if="showArea" :area-data="areaData" />
        </el-col>
      </el-row>
    </div>
    <el-link style="margin: 10px 15px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div>
      <el-row style="margin: 10px 15px">
        <el-col :span="24">
          <el-table
            v-loading="loading"
            border
            size="mini"
            :height="tableData.length > 0 ? 420 : 180"
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            :row-class-name="tableRowClassName"
            :data="tableData"
          >
            <el-table-column type="index" label="序号" width="50" fixed>
            </el-table-column>
            <el-table-column prop="name" label="行业" fixed> </el-table-column>
            <el-table-column label="趋势" width="50" fixed>
              <template slot-scope="scope">
                <el-link type="primary" @click="showDialog(scope.row)">
                  <i style="font-size: 20px" class="el-icon-data-analysis"></i>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="当月数据" v-if="this.dataTpye !== 'all'">
              <el-table-column
                prop="curr"
                :formatter="handelFix2"
                label="当期（亿元）"
              >
              </el-table-column>
              <el-table-column
                prop="pre"
                :formatter="handelFix2"
                label="上年同期（亿元）"
              >
              </el-table-column>
              <el-table-column
                prop="growthRate"
                :formatter="handelFix1"
                label="同比增长(%)"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column label="本年累计">
              <el-table-column
                prop="currCount"
                :formatter="handelFix2"
                label="当期（亿元）"
              >
              </el-table-column>
              <el-table-column
                prop="preCount"
                :formatter="handelFix2"
                label="上年同期（亿元）"
              >
              </el-table-column>
              <el-table-column
                prop="growthRateCount"
                :formatter="handelFix1"
                label="同比增长(%)"
              >
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="pageBox">
        <el-pagination
          class="pagePC"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <van-pagination
          class="pagePhone"
          v-model="currentPage"
          :total-items="total"
          :items-per-page="20"
          :show-page-size="3"
          @change="changePage"
          force-ellipses
        />
      </div>
      <el-dialog
        :title="`${areaName} - ${
          dataIndexOptions.find((ele) => ele.value === dataIndex).label
        }`"
        :visible.sync="dialogTableVisible"
        width="90%"
        @close="closeMe"
        v-if="dialogTableVisible"
      >
        <indexContent
          v-on:changeDataIndex="changeDataIndex"
          :title="`${areaName}_${
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }`"
          :data-tpye-def="dataTpye"
          :region-code-def="areaCode"
          :data-index-def="dataIndex"
          :data-range-def="dataRange"
          :times-def="times"
        ></indexContent>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Area from "@/components/Echarts/areaRotate1.vue";
import quarter from "@/components/dateUtils/quarter.vue";
import indexContent from "./indexContent";
import { export2Excel } from "@/utils/utils";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showArea: false,
      loading: false,
      areaName: "",
      currentPage: 1,
      page: 1,
      pageSize: 20,
      total: 0,
      dialogTableVisible: false,
      exportLabel: "<<点击此处可导出报表",
      queryData: {
        type: "T565",
      },
      dataIndexOptions: [
        {
          value: "gyzjz",
          label: "工业增加值",
        },
        {
          value: "yysr",
          label: "营业收入",
        },
        {
          value: "lrze",
          label: "利润总额",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: "currMonth", //时间类型
      dataIndex: "gyzjz", //数据指标
      dataRange: "month", //数据类型
      times: "", //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      srcTableData: [],
      tableTempData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      },
      rowName: "",
      spanConfig: {},
    };
  },
  components: {
    Area,
    indexContent,
    quarter,
  },
  watch: {
    dataRange: function (value, oldValue) {
      if (value === "quarter") {
        this.times = this.defaultQuarterValue;
      } else if (value === "month") {
        this.times = this.defaultMonthValue;
      } else {
        this.times = this.defaultMonthValue;
      }
      this.initData();
    },
  },
  methods: {
    changePage() {
      this.page = this.currentPage;
      this.handPageData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.handPageData();
    },
    handleCurrentChange(val) {
      //跳转页
      this.page = val;
      this.handPageData();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    handelFix1(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        if (row.nameIndex) {
          // 如果有值,说明需要合并
          return [row.nameIndex, 1];
        } else return [0, 0];
      }
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else {
        this.dataTpye = "all";
      }
    },
    showDialog(row) {
      this.showArea = false;
      this.areaName = row.name;
      this.areaCode = row.name;
      this.dialogTableVisible = true;
    },
    closeMe() {
      this.showArea = true;
      this.dialogTableVisible = false;
    },
    handPageData() {
      this.tableData = [];
      const start = (this.page - 1) * this.pageSize;
      const end =
        start + this.pageSize > this.total ? this.total : start + this.pageSize;
      for (let i = start; i < end; i++) {
        const item = this.srcTableData[i];
        const temp = {
          trend: "趋势",
          p_name: item.p_name,
          name: item.name,
          code: item.code,
          counts: item.counts ? item.counts : 0,
        };
        if (this.dataRange === "quarter") {
          if (this.dataIndex === "gyzjz") {
            // 工业增加值
            temp.curr = item.add_this;
            temp.pre = item.add_last;
            temp.growthRate =
              item.add_last == 0
                ? "--"
                : ((item.add_this - item.add_last) / item.add_last) * 100;
            temp.currCount = item.add_this_count;
            temp.preCount = item.add_last_count;
            temp.growthRateCount =
              item.add_last_count == 0
                ? "--"
                : ((item.add_this_count - item.add_last_count) /
                    item.add_last_count) *
                  100;
          } else if (this.dataIndex === "yysr") {
            // 营业收入
            temp.curr = item.bus_this;
            temp.pre = item.bus_last;
            temp.growthRate =
              item.bus_last == 0
                ? "--"
                : ((item.bus_this - item.bus_last) / item.bus_last) * 100;
            temp.currCount = item.bus_this_count;
            temp.preCount = item.bus_last_count;
            temp.growthRateCount =
              item.bus_last_count == 0
                ? "--"
                : ((item.bus_this_count - item.bus_last_count) /
                    item.bus_last_count) *
                  100;
          } else if (this.dataIndex === "lrze") {
            // 利润总额
            temp.curr = item.profit_this;
            temp.pre = item.profit_last;
            temp.growthRate =
              item.profit_last == 0
                ? "--"
                : ((item.profit_this - item.profit_last) / item.profit_last) *
                  100;
            temp.currCount = item.profit_this_count;
            temp.preCount = item.profit_last_count;
            temp.growthRateCount =
              item.profit_last_count == 0
                ? "--"
                : ((item.profit_this_count - item.profit_last_count) /
                    item.profit_last_count) *
                  100;
          }
        } else {
          if (this.dataIndex === "gyzjz") {
            // 工业增加值
            temp.curr = item.add_this;
            temp.pre = item.add_last;
            temp.growthRate = item.add_sync;
            temp.currCount = item.add_this_count;
            temp.preCount = item.add_last_count;
            temp.growthRateCount =
              item.add_last_count == 0
                ? "--"
                : ((item.add_this_count - item.add_last_count) /
                    item.add_last_count) *
                  100;
          } else if (this.dataIndex === "yysr") {
            // 营业收入
            temp.curr = item.bus_this;
            temp.pre = item.bus_last;
            temp.growthRate = item.bus_sync;
            temp.currCount = item.bus_this_count;
            temp.preCount = item.bus_last_count;
            temp.growthRateCount =
              item.bus_last_count == 0
                ? "--"
                : ((item.bus_this_count - item.bus_last_count) /
                    item.bus_last_count) *
                  100;
          } else if (this.dataIndex === "lrze") {
            // 利润总额
            temp.curr = item.profit_this;
            temp.pre = item.profit_last;
            temp.growthRate = item.profit_sync;
            temp.currCount = item.profit_this_count;
            temp.preCount = item.profit_last_count;
            temp.growthRateCount =
              item.profit_last_count == 0
                ? "--"
                : ((item.profit_this_count - item.profit_last_count) /
                    item.profit_last_count) *
                  100;
          }
        }
        this.tableData.push(temp);
      }
    },
    initData() {
      const self = this;
      this.loading = true;
      if (this.dataRange === "month") {
        this.queryData.dateType = "month";
        this.queryData.date = this.times;
      } else if (this.dataRange === "quarter") {
        this.queryData.dateType = "quarter";
        this.queryData.date = this.times;
      } else {
        this.queryData.dateType = "year";
        this.queryData.date = this.times;
      }
      this.$axios
        .post("/business/industry/query", this.queryData)
        .then((res) => {
          this.tableTempData = [];
          this.showArea = false;
          this.loading = false;
          this.srcTableData = JSON.parse(JSON.stringify(res.data));
          this.total = res.data.length;
          if (res.data && res.data.length > 0) {
            this.areaData = {
              xAxis: [],
              curr: {
                name: "",
                data: [],
              },
              pre: {
                name: "",
                data: [],
              },
              profit: {
                name: "",
                data: [],
              },
              unit: "亿元",
            };
            res.data.forEach((item) => {
              const temp = {
                trend: "趋势",
                p_name: item.p_name,
                name: item.name,
                code: item.code,
                counts: item.counts ? item.counts : 0,
              };
              this.areaData.xAxis.push(item.name);
              if (this.dataRange === "quarter") {
                if (this.dataIndex === "gyzjz") {
                  // 工业增加值
                  temp.curr = item.add_this;
                  temp.pre = item.add_last;
                  temp.growthRate =
                    item.add_last == 0
                      ? "--"
                      : ((item.add_this - item.add_last) / item.add_last) * 100;
                  temp.currCount = item.add_this_count;
                  temp.preCount = item.add_last_count;
                  temp.growthRateCount =
                    item.add_last_count == 0
                      ? "--"
                      : ((item.add_this_count - item.add_last_count) /
                          item.add_last_count) *
                        100;
                } else if (this.dataIndex === "yysr") {
                  // 营业收入
                  temp.curr = item.bus_this;
                  temp.pre = item.bus_last;
                  temp.growthRate =
                    item.bus_last == 0
                      ? "--"
                      : ((item.bus_this - item.bus_last) / item.bus_last) * 100;
                  temp.currCount = item.bus_this_count;
                  temp.preCount = item.bus_last_count;
                  temp.growthRateCount =
                    item.bus_last_count == 0
                      ? "--"
                      : ((item.bus_this_count - item.bus_last_count) /
                          item.bus_last_count) *
                        100;
                } else if (this.dataIndex === "lrze") {
                  // 利润总额
                  temp.curr = item.profit_this;
                  temp.pre = item.profit_last;
                  temp.growthRate =
                    item.profit_last == 0
                      ? "--"
                      : ((item.profit_this - item.profit_last) /
                          item.profit_last) *
                        100;
                  temp.currCount = item.profit_this_count;
                  temp.preCount = item.profit_last_count;
                  temp.growthRateCount =
                    item.profit_last_count == 0
                      ? "--"
                      : ((item.profit_this_count - item.profit_last_count) /
                          item.profit_last_count) *
                        100;
                }
              } else {
                if (this.dataIndex === "gyzjz") {
                  // 工业增加值
                  temp.curr = item.add_this;
                  temp.pre = item.add_last;
                  temp.growthRate = item.add_sync;
                  temp.currCount = item.add_this_count;
                  temp.preCount = item.add_last_count;
                  temp.growthRateCount =
                    item.add_last_count == 0
                      ? "--"
                      : ((item.add_this_count - item.add_last_count) /
                          item.add_last_count) *
                        100;
                } else if (this.dataIndex === "yysr") {
                  // 营业收入
                  temp.curr = item.bus_this;
                  temp.pre = item.bus_last;
                  temp.growthRate = item.bus_sync;
                  temp.currCount = item.bus_this_count;
                  temp.preCount = item.bus_last_count;
                  temp.growthRateCount =
                    item.bus_last_count == 0
                      ? "--"
                      : ((item.bus_this_count - item.bus_last_count) /
                          item.bus_last_count) *
                        100;
                } else if (this.dataIndex === "lrze") {
                  // 利润总额
                  temp.curr = item.profit_this;
                  temp.pre = item.profit_last;
                  temp.growthRate = item.profit_sync;
                  temp.currCount = item.profit_this_count;
                  temp.preCount = item.profit_last_count;
                  temp.growthRateCount =
                    item.profit_last_count == 0
                      ? "--"
                      : ((item.profit_this_count - item.profit_last_count) /
                          item.profit_last_count) *
                        100;
                }
              }
              if (this.dataTpye === "all") {
                this.areaData.curr.name = "累计";
                this.areaData.pre.name = "上年同期";
                this.areaData.profit.name = "同比增速";
                this.areaData.curr.data.push(temp.currCount);
                this.areaData.pre.data.push(temp.preCount);
                this.areaData.profit.data.push(temp.growthRateCount);
              } else {
                this.areaData.curr.name = "当期";
                this.areaData.pre.name = "上年同期";
                this.areaData.profit.name = "同比增速";
                this.areaData.curr.data.push(temp.curr);
                this.areaData.pre.data.push(temp.pre);
                this.areaData.profit.data.push(temp.growthRate);
              }
              this.tableTempData.push(temp);
            });
          } else {
            if (this.dataTpye === "all") {
              this.areaData = {
                xAxis: [
                  "轻工业",
                  "重工业",
                  "先进装备制造",
                  "新材料",
                  "高端石化",
                  "电子信息",
                  "旅游业",
                  "机器人与智能制造",
                  "新能源",
                  "生物医药",
                  "电子商务",
                  "金融",
                  "现代物流",
                  "文化产业",
                  "科技服务",
                  "牡丹业",
                  "健康养老",
                  "高效农业",
                ],
                curr: {
                  name: "累计",
                  data: [
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                  ],
                },
                pre: {
                  name: "上年同期",
                  data: [
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                  ],
                },
                profit: {
                  name: "同比增速",
                  data: [
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                  ],
                },
                unit: "亿元",
              };
            } else {
              this.areaData = {
                xAxis: [
                  "轻工业",
                  "重工业",
                  "先进装备制造",
                  "新材料",
                  "高端石化",
                  "电子信息",
                  "旅游业",
                  "机器人与智能制造",
                  "新能源",
                  "生物医药",
                  "电子商务",
                  "金融",
                  "现代物流",
                  "文化产业",
                  "科技服务",
                  "牡丹业",
                  "健康养老",
                  "高效农业",
                ],
                curr: {
                  name: "当期",
                  data: [
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                  ],
                },
                pre: {
                  name: "上年同期",
                  data: [
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                  ],
                },
                profit: {
                  name: "同比增速",
                  data: [
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                    "--",
                  ],
                },
                unit: "亿元",
              };
            }
          }
          this.handPageData();
          setTimeout(function () {
            self.showArea = true;
          }, 5);
        });
    },
    getQuarter(value) {
      this.times = value;
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
      //下面是几个if
      if (month >= 1 && month <= 3)
        return year + "-" + "01" + "," + year + "-" + "03";
      else if (month >= 4 && month <= 6) {
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
    monthChange(value) {
      this.initData();
    },
    yearChange(value) {
      this.times = value + "-12";
      this.times =
        this.defaultMonthValue > this.times
          ? this.times
          : this.defaultMonthValue;
      this.initData();
    },
    changeDataIndex(value) {
      if (value) {
        this.dataIndex = value;
      }
    },
    exportData() {
      let column = [];
      if (this.dataRange === "year") {
        column = [
          {
            title: "行业",
            key: "name",
            rowspan: 2,
          },
          {
            title: "本年累计",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "currCount",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "preCount",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRateCount",
              },
            ],
            colspan: 3,
          },
        ];
      } else {
        column = [
          {
            title: "行业",
            key: "name",
            rowspan: 2,
          },
          {
            title:
              this.dataRange === "quarter"
                ? "当季数据"
                : this.dataRange === "year"
                ? "当年数据"
                : "当月数据",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "curr",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "pre",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRate",
              },
            ],
            colspan: 3,
          },
          {
            title: "本年累计",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "currCount",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "preCount",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRateCount",
              },
            ],
            colspan: 3,
          },
        ];
      }
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr = this.times.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        let quarter = "";
        if (this.times.slice(5, 7) === "01") {
          quarter = "1";
        } else if (this.times.slice(5, 7) === "04") {
          quarter = "2";
        } else if (this.times.slice(5, 7) === "07") {
          quarter = "3";
        } else if (this.times.slice(5, 7) === "10") {
          quarter = "4";
        }
        timeStr = this.times.slice(0, 4) + "年第" + quarter + "季度";
      } else {
        timeStr = this.times.slice(0, 4) + "年" + this.times.slice(5, 7) + "月";
      }
      export2Excel(
        column,
        this.tableTempData,
        this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
          .label +
          "_" +
          timeStr
      );
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.times = this.defaultMonthValue;
    this.initData();
  },
};
</script>
<style lang="less" scoped>
.pagePhone {
  display: none;
}
@media (max-width: 1200px) {
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
</style>